module.exports = __webpack_public_path__ + "media/images/countryrect/sl-ea56ab6ba00050898a1316c96ae663e4.svg";